import { ColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";

export class ContractsDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}